<template>
    <div>
        <div class="row col-12 m-0 px-0 d-flex justify-content-between">
            <h4 class="font-weight-bold">Mais Informações</h4>
        </div>
        <load mode="table" v-if="loading" />
        <div v-else class="row">
            <div class="col-md-4">
                <img
                    v-if="informacao.foto"
                    :src="url + informacao.foto"
                    alt=""
                    class="img-fluid"
                />
                <img
                    v-else
                    :src="url + 'img/avatar_default.png'"
                    alt=""
                    class="img-fluid"
                />
            </div>
            <div class="col-md-8">
                <form-textarea
                    class="mt-0 px-0"
                    v-model="informacao.observacoes"
                    label="Observação"
                />
                <form-file
                    class="px-0"
                    @submit="submitFile"
                    label="Upload da foto do usuario"
                    textInput="Escolher um imagem como foto"
                />
                <!-- <button class="btn-block btn btn-primary">
					<i class="mdi mdi-18px mdi-camera"></i> Tirar Foto com Webcam
				</button> -->
                <button
                    class="btn-block btn btn-primary"
                    @click="openModalBiometria"
                >
                    <i class="mdi mdi-18px mdi-fingerprint"></i> Colher
                    Biometria
                </button>
            </div>
        </div>
        <div class="row pt-4 px-2 d-flex justify-content-end">
            <button @click="submit" class="btn btn-success btn-submit">
                <i class="mdi mdi-content-save"></i>
                Salvar
            </button>
        </div>
        <ModalBIometria />
    </div>
</template>
<script>
import ModalBIometria from "./GetBiometria";
export default {
    components: { ModalBIometria },
    props: ["item"],
    data() {
        return {
            url: `${window.location.protocol}//${window.location.host}/`,
            informacao: {},
            files: [],
            progressCompleted: 0,
            loading: false,
        };
    },
    mounted() {
        this.setValue();
    },
    watch: {
        item(n, o) {
            this.setValue();
        },
    },
    methods: {
        openModalBiometria() {
            this.$bvModal.show("create-biometria");
        },
        setValue() {
            if (this.item.informacao != null) {
                this.informacao = this.item.informacao;
            }
        },
        submitFile(files) {
            this.files = files;
        },
        submit() {
            let formData = new FormData();

            formData.append("foto", this.files);
            formData.append("nome_completo", this.item.nome_completo);
            formData.append("familia_id", this.item.familia_id);
            formData.append("id", this.item.id);

            this.loading = true;
            axios
                .post(`api/dashboard/usuarios/upload`, formData, {
                    header: { "Content-Type": "multipart/form-data" },
                    onUploadProgress: (event) => {
                        let progress = Math.round(
                            (event.loaded * 100) / event.total
                        );
                        this.progressCompleted = progress;
                    },
                })
                .then((response) => {
                    this.progressCompleted = 0;
                    this.loading = false;
                })
                .catch((error) => {
                    this.loading = false;
                });

            if (this.files) {
                this.item.informacao.foto = this.files.name;
            }
            this.item.informacao = this.informacao;
            this.$emit("submit");
        },
    },
};
</script>
